export enum MethodsSort {
    UP = "up",
    DOWN = "down",
}
